import type { ElementType, HTMLAttributes, ReactElement } from "react";
import styles from "./Surface.module.css";

export type SurfaceElevation = "flat" | "raised";
export type SurfacePadding = "none" | "compact" | "default";

export interface SurfaceProps extends HTMLAttributes<HTMLElement> {
  /** `flat` is the default panel; `raised` is for a focal card (the sign-in card). */
  elevation?: SurfaceElevation;
  /** `none` lets a full-bleed child (a table) reach the panel's edges. */
  padding?: SurfacePadding;
  as?: ElementType;
}

/**
 * The elevated panel every view sits on: a bordered, rounded card on the
 * tinted canvas. Purely presentational — pick `as` for the right semantics
 * (`section`, `article`) and give it a heading so the region is announced.
 */
export function Surface({
  elevation = "flat",
  padding = "default",
  as: Component = "div",
  className,
  children,
  ...rest
}: SurfaceProps): ReactElement {
  const classes = [styles.surface, styles[elevation], styles[`padding-${padding}`], className]
    .filter(Boolean)
    .join(" ");
  return (
    <Component className={classes} {...rest}>
      {children}
    </Component>
  );
}
